import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import CategoryTreeSelect from "./CategoryTreeSelect";

/**
 * Values match question_bank_questions.source_type. "past-paper" is hyphenated because
 * that is the spelling attachPastPaper writes and the question bank list filter expects.
 */
export const SAVE_SOURCE_TYPES = [
  { value: "past-paper", label: "Past Papers" },
  { value: "ai_generated", label: "AI Generated Papers" },
  { value: "mock_exam", label: "Mock Exam" },
];

/**
 * Category + "Save as" source type, shared by the MCQ conversion and Similar Paper flows.
 */
const CategorySaveFields = ({
  categoryId,
  onCategoryChange,
  sourceType,
  onSourceTypeChange,
  disabled = false,
  categoryLabel = "Category",
  helperText,
}) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
    <CategoryTreeSelect
      label={categoryLabel}
      value={categoryId ?? ""}
      onChange={onCategoryChange}
      size="small"
      fullWidth
      disabled={disabled}
    />

    <FormControl disabled={disabled}>
      <FormLabel sx={{ fontSize: "0.85rem", fontWeight: 600, mb: 0.5 }}>Save as</FormLabel>
      <RadioGroup
        row
        value={sourceType || "ai_generated"}
        onChange={(e) => onSourceTypeChange(e.target.value)}
      >
        {SAVE_SOURCE_TYPES.map((opt) => (
          <FormControlLabel
            key={opt.value}
            value={opt.value}
            control={<Radio size="small" />}
            label={opt.label}
          />
        ))}
      </RadioGroup>
    </FormControl>

    {helperText && (
      <Typography variant="caption" color="text.secondary">
        {helperText}
      </Typography>
    )}
  </Box>
);

export default CategorySaveFields;
